import { ScoreBoard as ScoreBoardComponent } from './ScoreBoard.component';
import { connector } from './ScoreBoard.connector';

export const ScoreBoard = connector(ScoreBoardComponent);
